import {promises as fs} from 'node:fs';
import {execa} from 'execa';
import {writePackageJson} from '@form8ion/javascript-core';

export default async function scaffoldYarn({projectRoot}) {
  const [packageContents, {stdout}] = await Promise.all([
    fs.readFile(`${projectRoot}/package.json`, 'utf-8'),
    execa('yarn', ['--version'])
  ]);
  const existingPackageJsonContents = JSON.parse(packageContents);

  await writePackageJson({
    projectRoot,
    config: {
      ...existingPackageJsonContents,
      packageManager: `yarn@${stdout}`
    }
  });
}
